import { apCalcABPart1 } from '../ap-calc-ab/data-part1';
import { apCalcABPart2 } from '../ap-calc-ab/data-part2';
import { apCalcABPart3 } from '../ap-calc-ab/data-part3';
import { apCalcBCOnly } from './data-bc-only';

export const apCalcBCData = [
  ...apCalcABPart1,
  ...apCalcABPart2,
  ...apCalcABPart3,
  ...apCalcBCOnly,
];
